/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-26 10:01:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-28 15:55:57
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1/dict`;
const tempRequestUrl = `${window.env.scimSystem}/api/v1/`;
const api = {
  // 列表
  getList: params => request({
    url: `${requestUrl}/page`,
    method: "get",
    params
  }),
  // 导出
  exportDict() {
    return request({
      url: `${requestUrl}/export-dict`,
      method: "get",
      responseType: "blob"

    });
  },
  // 导入
  importDict(data, templateCode) {
    return request({
      url: `${tempRequestUrl}/excel/template/${templateCode}/import`,
      method: "post",
      data
    });
  },
  // 新增字典
  addDict: data => request({
    url: `${requestUrl}/cascade-dict`,
    method: "post",
    data
  }),
  // 修改字典
  editDict: data => request({
    url: `${requestUrl}/cascade-dict`,
    method: "put",
    data
  }),
  // 通过id查找详细字典信息 查看和编辑
  getDictById: id => request({
    url: `${requestUrl}/item/dict-id/${id}`,
    method: "get"
  }),
  // 通过id删除字典
  deleteDictById: id => request({
    url: `${requestUrl}/${id}`,
    method: "delete"
  })
};

export default api;
